export default "<p>hulk-config-tailwindcss works!</p>\r\n"